import { createMemoryHistory, createBrowserHistory } from 'history';

import config from '../config';

const RESTRICTED_RESTORE_PATHS = ['/signup', '/psignup', '/teams'];
const HISTORY_RESTORE_ENABLED = config.HISTORY_TYPE === 'memory';

let initialEntries;
let historyTs;

try {
    if (HISTORY_RESTORE_ENABLED) {
        historyTs = Number(localStorage.getItem('location_history_ts') || Number.POSITIVE_INFINITY);

        if (Date.now() - historyTs > 10000) {
            initialEntries = JSON.parse(localStorage.getItem('location_history') || '[]');
        }

        const pathname = initialEntries?.[0]?.pathname;

        if (pathname && RESTRICTED_RESTORE_PATHS.some(path => pathname.indexOf(path) === 0)) {
            initialEntries = null;
        }

        localStorage.setItem('location_history_ts', Date.now());
    }
} catch (e) {}

export const browserHistory = (config.HISTORY_TYPE === 'memory' ? createMemoryHistory : createBrowserHistory)({
    basename: '/',
    initialEntries: initialEntries?.length ? initialEntries : undefined,
    initialIndex: initialEntries?.length || undefined
});


if (HISTORY_RESTORE_ENABLED) {
    browserHistory.listen(entry => {
        localStorage.setItem('location_history', JSON.stringify([entry]));
        localStorage.setItem('location_history_ts', Date.now());
    });
}
